var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chat-online-status",class:_vm.statusClass,attrs:{"title":_vm.statusText}},[_c('span',{staticClass:"status-dot"}),(_vm.showLabel)?_c('span',{staticClass:"status-label"},[_vm._v(_vm._s(_vm.statusText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }